import { render, staticRenderFns } from "./Package1Card.vue?vue&type=template&id=699df90c&scoped=true"
import script from "./Package1Card.vue?vue&type=script&lang=ts"
export * from "./Package1Card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "699df90c",
  null
  
)

export default component.exports